import { Injectable, EventEmitter } from "@angular/core";

@Injectable()
export class SettingsMenuService {
  active = false;
  active$ = new EventEmitter();

  constructor() {}

  show() {
    this.active = true;
    this.active$.emit(true);
  }

  hide() {
    this.active = false;
    this.active$.emit(false);
  }
}
